import React from "react"

export const FieldContainer = ({children}) => {
    return <div className="margin10">{children}</div>
}